import React from "react";
import { Grid } from "@mui/material";
import FileUpload from "../../utils/FileUpload";
import ModelImage from "../../assets/img/modelImage.png";
import { useLoading } from "../../common/LoadingContext";
import { useNotificationContext } from "../../common/NotificationContext";
import {
  DownloadErrorLogsService,
  uploadBulkModelsService,
  DownloadModelsTemplateService,
} from "../../services/BulkUploadServices";
import download from "downloadjs";
import useGlobalState from "../../../src/Context";

const BulkModelsUpload = () => {
  const { setLoading } = useLoading();
  const { showNotification } = useNotificationContext();
  const [{ auth }, dispatch] = useGlobalState();
  const loggedInUserId = auth.ldapParam.userId;
  const downloadTemplate = async () => {
    try {
      setLoading(true);
      const response = await DownloadModelsTemplateService();
      const content = response.headers["content-type"];
      download(response.data, "ModelsTemplate.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const downloadErrorLogs = async () => {
    try {
      setLoading(true);
      const param = {
        requestType: 1,
        id: loggedInUserId,
      };
      const response = await DownloadErrorLogsService(param);
      const content = response.headers["content-type"];
      download(response.data, "ModelErrorLogs.csv", content);
    } catch (err) {
      showNotification("Error", "Failed To Fetch");
    } finally {
      setLoading(false);
    }
  };

  const onFileChange = (event) => {
    if (
      event.target.files[0]?.type === "text/csv" ||
      event.target.files[0]?.type === "application/vnd.ms-excel" ||
      event.target.files[0]?.type === "application/vnd.msexcel" ||
      event.target.files[0]?.type === "application/csv" ||
      event.target.files[0]?.type === "text/comma-separated-values"
    ) {
      if (event.target.files[0].size >= 10485760) {
        // allowing only file less than 10mbs
        showNotification(
          "Error",
          "File too Big, please select a file less than 10mb"
        );
      } else {
        uploadFile(event.target.files[0]);
      }
    } else {
      showNotification("Error", "Invalid type selected, Please try again.");
    }
  };

  const uploadFile = async (file) => {
    const formData = new FormData();
    var userId = JSON.stringify(loggedInUserId);
    formData.append("file", file);
    formData.append("userId", userId);
    try {
      setLoading(true);
      const uploadResponse = await uploadBulkModelsService(formData);
      if (uploadResponse.statusCode === 6) {
        showNotification("Success", uploadResponse.data.message, "success");
      } else {
        showNotification("Error", uploadResponse.data.message, "error");
      }
    } catch (err) {
      showNotification("Error", "Failed To submit File");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Grid container spacing={1} sx={{ mt: 0,pb: 1,alignItems:"center" }}>
        <Grid item xs={3} sx={{ mt: "0" }}>
          <img src={ModelImage} alt="Model" width={60} />
        </Grid>
        <Grid item xs={4} sx={{ color: "#757575", fontSize: "16px", fontWeight: "500", mt: "0" }}>
          <p>Bulk Models </p>
        </Grid>

        <Grid item xs={5} sx={{ mt: "0",textAlign:"left" }}>
          <FileUpload
            onFileChange={onFileChange}
            modelButton={true}
            showDownload={true}
            download={downloadTemplate}
            downloadErrors={downloadErrorLogs}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default BulkModelsUpload;
